<template>
  <div>
    <v-card-text>
      <br />
      <v-range-slider
        v-if="DateRangeOptions"
        v-model="selectedDates"
        :min="selectedStartDate"
        :max="selectedEndDate"
        thumb-label="always"
        ticks="always"
        :hint="$i18n.t('select_start_and_end_years')"
        persistent-hint
        @change="dateChoice()"
      ></v-range-slider>
      <br />
      <v-switch
        v-model="byYear"
        :label="$i18n.t('display_year_information')"
        @change="dateChoice()"
      ></v-switch>
    </v-card-text>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "DateRangeForm",
  components: {},
  props: {
    cim: {
      type: Function,
      required: true,
      default: function() {
        return ["9", "10"];
      }
    }
  },
  data: () => ({
    DateRangeOptions: null,
    selectedStartDate: null,
    selectedEndDate: null,
    selectedDates: [],
    byYear: true,
    error: null
  }),
  computed: {},
  methods: {
    availableDateRange: function() {
      this.error = false;
      axios
        .get("bcmd/r/years", {
          params: {
            cim: this.cim()
          }
        })
        .then(response => {
          this.DateRangeOptions = response.data;
          this.selectedStartDate = this.DateRangeOptions[0];
          this.selectedEndDate = this.DateRangeOptions[
            this.DateRangeOptions.length - 1
          ];
          this.selectedDates[0] = this.selectedEndDate;
          this.selectedDates[1] = this.selectedEndDate;
        })
        .catch(() => {
          this.error = true;
        });
    },
    dateChoice: function() {
      if (this.selectedDates[0] > this.selectedDates[1]) {
        this.selectedDates[1] = this.selectedDates[0];
      }
      this.$emit("update-date", {
        byYear: this.byYear,
        selectedDates: this.selectedDates
      });
      return true;
    }
  },
  beforeMount() {
    this.availableDateRange();
  }
};
</script>
